import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Grid, Segment } from "semantic-ui-react";
import swal from "sweetalert";
import AlunosSelector from "../../../components/Admin/AlunosSelector";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import Loading from "../../../components/Loading";
import { useRouter } from "../../../hooks/router";
import { producaov2 } from "../../../services/apis";
import { getUserNode } from "../../../services/auth_node";
import { systemLogs } from "../../../services/system_logs";
import { limpaTituloCurso } from "../../../utils/Utils";
import ListarCurso from "./ListarCurso";
import { Container, Title } from "./styled";

function GeradorCertificadoCriar() {
  const [tipo, setTipo] = useState(1);
  const [cursos, setCursos] = useState([]);
  const [alunos, setAlunos] = useState([]);

  const [currentAluno, setCurrentAluno] = useState({});
  const [currentCurso, setCurrentCurso] = useState({});

  const [searchAluno, setSearchAluno] = useState("");
  const [searchCurso, setSearchCurso] = useState("");

  const [projetosExterno, setProjetosExterno] = useState(["", "", ""]);
  const [linkCertificado, setLinkCertificado] = useState("");

  const [loading, setLoading] = useState(true);
  const [loadingSendEmail, setLoadingSendEmail] = useState(false);
  const [loadingGenerator, setLoadingGenerator] = useState(false);

  const router = useRouter();

  const loadURLCursoAluno = useCallback(async () => {
    const { id_curso, id_aluno, opcao } = router.query;

    const newCursos = await producaov2
      .get("admin/cursos/list-for-gerador-certificados")
      .then((res) =>
        res.data.cursos.filter(
          (curso) =>
            curso.id === 3462 ||
            curso.id === 3467 ||
            curso.id === 3642 ||
            curso.id === 4623
        )
      )
      .catch((err) => {
        console.error(err);
        return [];
      });

    setCursos(newCursos);

    // const newAlunos = await producaov2
    //   .get("admin/pessoas/list-for-gerador-certificados")
    //   .then((res) => res.data.pessoas)
    //   .catch((err) => {
    //     console.error(err);
    //     return [];
    //   });

    // setAlunos(newAlunos);

    setTipo(opcao ? Number(opcao) : 1);

    if (id_curso) {
      setSearchCurso(id_curso);
    }

    if (id_aluno) {
      setSearchAluno(id_aluno);
    }

    if (
      // Number(currentAluno.id) === Number(id_aluno) &&
      Number(currentCurso.id) === Number(id_curso)
    ) {
      return;
    }

    // const foundAluno = newAlunos.find(
    //   (aluno) => Number(aluno.id) === Number(id_aluno)
    // );

    // if (foundAluno && !currentAluno.id) {
    //   setCurrentAluno(foundAluno);
    // }

    const foundCurso = newCursos.find(
      (curso) => Number(curso.id) === Number(id_curso)
    );

    if (foundCurso && !currentCurso.id) {
      setCurrentCurso(foundCurso);
    }

    setLoading(false);
  }, [router, currentAluno, currentCurso]);

  useEffect(() => {
    setLoading(true);
    loadURLCursoAluno();
  }, [router]);

  useEffect(() => {
    if (!searchAluno) {
      return;
    }

    producaov2
      .get(`alunos/${searchAluno}`)
      .then((res) => {
        if (!res.data.aluno) {
          return;
        }

        setCurrentAluno(res.data.aluno);
      })
      .catch((err) => console.error(err));
  }, [searchAluno]);

  const genCertify = useCallback(async () => {
    if ([1, 2, 5, 8].includes(Number(tipo)) && !currentCurso.id) {
      swal("Erro", "Informe o curso para gerar o certificado", "error");
      return null;
    }

    if (!currentAluno.id) {
      swal("Erro", "Informe o aluno para gerar o certificado", "error");
      return null;
    }

    setLoadingGenerator(true);

    const id_curso = currentCurso.id
    ? currentCurso.id
    : Number(tipo) === 4
    ? 3216
    : Number(tipo) === 7 || Number(tipo) === 8 || Number(tipo) === 9
    ? 3492
    : 0;

    const quantidadeProjetosInterno =
      Number(tipo) === 4 || Number(tipo) === 7
        ? 2
        : Number(tipo) === 3 || Number(tipo) === 6 || Number(tipo) === 9
        ? 0
        : 1;

    const defaultInternalCourseIds = [3462, 3467];
    
    const internalCourseIds = quantidadeProjetosInterno === 2 ? defaultInternalCourseIds : [currentCurso.id]
    const payload = {
      courseId: id_curso.toString(),
      userId: currentAluno.id,
      needRegenerate: true,
      internalProjectIds:internalCourseIds,
      externalProjectsName: projetosExterno.filter((projeto) => projeto),
    };

    try {
      const certificadoResponse = await producaov2.post("/admin/certificate", payload);

      await producaov2.post("certificado_by_gerador", {
        aluno: currentAluno.nome,
        link: certificadoResponse.data.url,
        id_inserido_por: getUserNode().id,
        email: currentAluno.email,
        cod: payload.id_curso + currentAluno.id,
      });

      setLinkCertificado(certificadoResponse.data.url);
      setLoadingGenerator(false);

      await producaov2.post("certificado/aluno/email", {
        id_aluno: payload.id_aluno,
        id_curso: payload.id_curso,
        projetosExterno: projetosExterno.filter((projeto) => projeto),
      });

      systemLogs(
        "GeradorCertificadoCriar",
        `Gerou o certificado para o aluno (${alunos.id})`
      );

      swal(
        "Operação bem sucedida!",
        "Certificado gerado com sucesso, baixe-o ou envie por email do aluno nas opções abaixo.",
        "success"
      );
    } catch (err) {
      console.error(err);

      swal(
        "Houve um erro...",
        "Houve um erro ao registrar a geracao do certificado.",
        "error"
      );
    }
  }, [searchAluno, currentCurso, currentAluno, tipo, projetosExterno]);

  const sendCertificado = useCallback(async () => {
    setLoadingSendEmail(true);

    const isPpa = [3462, 3467].includes(Number(currentCurso.id));

    const payload = isPpa
      ? {
          nome: currentAluno.nome,
          email: currentAluno.email,
          cc: "voitto@voitto.com.br, gabriel.eduardo@voitto.com.br",
          model: 29,
          assunto: "Parabéns! Seu certificado Seis Sigma está pronto!",
          context: {
            nome: currentAluno.nome,
            url: linkCertificado,
          },
        }
      : {
          nome: currentAluno.nome,
          email: currentAluno.email,
          cc: "voitto@voitto.com.br",
          model: 68,
          assunto: "Seu certificado já está disponível!",
          context: {
            nome_aluno: currentAluno.nome,
            nome_curso: limpaTituloCurso(currentCurso.titulo),
            linkCertificado,
          },
        };

    try {
      await producaov2.post("mail/send", payload);

      swal(
        "Certificado enviado!",
        "Certificado enviado para o aluno!",
        "success"
      );
      setLoadingSendEmail(false);
    } catch (err) {
      console.error(err);

      swal(
        "Ops...",
        "Houve um erro ao enviar o certificado por email",
        "error"
      );
      setLoadingSendEmail(false);
    }
  }, [currentAluno, currentCurso, linkCertificado]);

  const handleProjetosExternos = useCallback(
    (value, index) => {
      const newProjetosExterno = [...projetosExterno];
      newProjetosExterno[index] = value;
      setProjetosExterno(newProjetosExterno);
    },
    [projetosExterno]
  );

  const handleAlunoChange = (value) => {
    setSearchAluno(value);
  };

  if (loading) {
    return (
      <>
        <AdminMenu />
        <Loading msg={"Carregando..."} />
      </>
    );
  }

  return (
    <>
      <AdminMenu />
      <Container style={{ paddingBottom: 60 }}>
        <Title>Gerador de certificado interno</Title>
        <Form>
          <Form.Field>
            <label>Origem do certificado</label>
            <select
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
              label="Origem do certificado"
              control="select"
            >
              <option value="1">Cursos normais</option>
              <option value="2">Especialista Green Belt (ppa único)</option>
              <option value="3">
                Especialista Green Belt (projeto externo)
              </option>
              <option value="4">
                Especialista Black Belt (ppa's internos)
              </option>
              <option value="5">
                Especialista Black Belt (ppa único interno e projeto externo)
              </option>
              <option value="6">
                Especialista Black Belt (2 projetos externos)
              </option>
              <option value="7">
                Especialista Master Black Belt (2 PPAs internos + projeto
                externo)
              </option>
              <option value="8">
                Especialista Master Black Belt (1 PPA interno + 2 projetos
                externos)
              </option>
              <option value="9">
                Especialista Master Black Belt (3 projetos externos)
              </option>
            </select>
          </Form.Field>

          {(Number(tipo) === 1 || Number(tipo) === 2) && (
            <>
              <Form.Field>
                <label>
                  Busque o curso do certificado pelo ID ou pelo seu nome
                </label>
                <input
                  value={searchCurso}
                  onChange={(e) => setSearchCurso(e.target.value)}
                  placeholder="Busque o curso do certificado pelo ID ou pelo seu nome"
                />
              </Form.Field>

              <ListarCurso
                cursos={cursos}
                searchCurso={searchCurso}
                currentCurso={currentCurso}
                setSearchCurso={setSearchCurso}
                setCurrentCurso={setCurrentCurso}
              />

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) === 3 && (
            <>
              <Form.Field>
                <label>Nome do projeto externo</label>
                <input
                  value={projetosExterno[0]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 0)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) == 4 && !currentAluno.id && (
            <>
              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) === 5 && (
            <>
              <Form.Field>
                <label>Nome do projeto externo</label>
                <input
                  value={projetosExterno[0]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 0)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <Form.Field>
                <label>
                  Busque o curso do certificado pelo ID ou pelo seu nome
                </label>
                <input
                  value={searchCurso}
                  onChange={(e) => setSearchCurso(e.target.value)}
                  placeholder="Busque o curso do certificado pelo ID ou pelo seu nome"
                />
              </Form.Field>

              <ListarCurso
                cursos={cursos}
                searchCurso={searchCurso}
                currentCurso={currentCurso}
                setSearchCurso={setSearchCurso}
                setCurrentCurso={setCurrentCurso}
              />

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) === 6 && (
            <>
              <Form.Field>
                <label>Nome do projeto externo</label>
                <input
                  value={projetosExterno[0]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 0)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <Form.Field>
                <label>Nome do projeto externo</label>
                <input
                  value={projetosExterno[1]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 1)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) === 7 && (
            <>
              <Form.Field>
                <label>Nome do projeto externo</label>
                <input
                  value={projetosExterno[0]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 0)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) === 8 && (
            <>
              <Form.Field>
                <label>Nome do primeiro projeto externo</label>
                <input
                  value={projetosExterno[0]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 0)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <Form.Field>
                <label>Nome do segundo projeto externo</label>
                <input
                  value={projetosExterno[1]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 1)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <Form.Field>
                <label>
                  Busque o curso do certificado pelo ID ou pelo seu nome
                </label>
                <input
                  value={searchCurso}
                  onChange={(e) => setSearchCurso(e.target.value)}
                  placeholder="Busque o curso do certificado pelo ID ou pelo seu nome"
                />
              </Form.Field>
              <ListarCurso
                cursos={cursos}
                searchCurso={searchCurso}
                currentCurso={currentCurso}
                setSearchCurso={setSearchCurso}
                setCurrentCurso={setCurrentCurso}
              />

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}

          {Number(tipo) === 9 && (
            <>
              <Form.Field>
                <label>Nome do primeiro projeto externo</label>
                <input
                  value={projetosExterno[0]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 0)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <Form.Field>
                <label>Nome do segundo projeto externo</label>
                <input
                  value={projetosExterno[1]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 1)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <Form.Field>
                <label>Nome do terceiro projeto externo</label>
                <input
                  value={projetosExterno[2]}
                  onChange={(e) => handleProjetosExternos(e.target.value, 2)}
                  placeholder="Nome do projeto realizado por fora da Voitto"
                />
              </Form.Field>

              <AlunosSelector
                initialValue={searchAluno}
                handleChange={handleAlunoChange}
              />
            </>
          )}
        </Form>
        <br />
        <Grid stackable columns={3}>
          <Grid.Column>
            <Segment.Inline>
              <Button
                loading={loadingGenerator}
                primary
                onClick={() => genCertify()}
                type="button"
                class="ui button positive"
              >
                Gerar certificado{" "}
              </Button>
            </Segment.Inline>
          </Grid.Column>
          {linkCertificado !== "" && (
            <Grid.Column>
              <Segment.Inline>
                <a
                  href={linkCertificado}
                  target="_blank"
                  type="button"
                  class="ui button positive"
                  value="Baixar certificado"
                >
                  Baixar certificado
                </a>
              </Segment.Inline>
            </Grid.Column>
          )}
          {linkCertificado !== "" && (
            <Grid.Column>
              <Segment.Inline>
                <Button
                  loading={loadingSendEmail}
                  primary
                  onClick={() => sendCertificado()}
                  type="button"
                  class="ui button positive"
                >
                  Enviar certificado por email
                </Button>
              </Segment.Inline>
            </Grid.Column>
          )}
        </Grid>
      </Container>
    </>
  );
}

export default GeradorCertificadoCriar;
